
import { Grid, IconButton, Typography } from '@mui/material';
import { IRoom } from '../../../interfaces/IPartnerPms';
import { useCallback, useEffect, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import FormHelper from '../../../helpers/FormHelper';
import DefaultConstants from '../../../data/Constants';
import PartnerPmsService from '../../../services/PartnerPmsService';
import { RoomStatusData, RoomStatusEnum } from '../../../data/Enums';
import AddAttachmentsDialog from '../AddAttachmentsDialog';
import useState from '../../../hooks/useState';
import useDialog from '../../../hooks/useDialog';
import Badge from '../../Badge';
import { AttachFile } from '@mui/icons-material';


const doNotDisturb = RoomStatusData[RoomStatusEnum.DoNotDisturb];


interface IDoNotDisturbConfirmationDialogProps extends IDefaultDialogProps {
    room: IRoom;
    handleRefreshSelectedRoom: () => void;
}

interface IStateValues {
    attachments: File[];
}

const DoNotDisturbConfirmationDialog: React.FC<IDoNotDisturbConfirmationDialogProps> = ({
    open,
    handleClose,
    room,
    handleRefreshSelectedRoom
}) => {
    const { translate } = useLanguageContext();
    
    const state = useState<IStateValues>({
        attachments: []
    });

    const addAttachmentsDialog = useDialog();


    useEffect(() => {
        if (open) {
            addAttachmentsDialog.handleClose();
        }
        // eslint-disable-next-line
    }, [open]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        let formData = FormHelper.Create(undefined);
        formData = FormHelper.Add(formData, 'roomId', room.id);
        formData = FormHelper.Add(formData, 'reservationId', room.checkInReservation?.id);
        formData = FormHelper.Add(formData, 'enableDoNotDisturb', (!room.doNotDisturb).toString());

        state.values.attachments.forEach((attachment, index) => {
            formData = FormHelper.Add(formData, `attachment[${index}]`, attachment);
        });

        PartnerPmsService.UpdateRoomDoNotDisturb(formData).then(() => {
            handleRefreshSelectedRoom();
            handleClose();
        });
        // eslint-disable-next-line
    }, [room, state.values.attachments]);


    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='no' onClick={handleClose} />,
            <ActionButton action='yes' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return <>
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate(doNotDisturb.name)}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12} paddingBottom={2}>
                    <Typography variant='body1'>
                        {translate(room.doNotDisturb ? '_governanceDialogDisableDoNotDisturbDescription' : '_governanceDialogEnableDoNotDisturbDescription')}
                    </Typography>
                </Grid>

                <Grid item xs={12} className="display-flex alignitems-center justifycontent-flexend" paddingY={2}>
                    <Badge badgeContent={state.values.attachments.length} showZero={true} className='backgroundcolor-primary color-white'>
                        <IconButton size="large" onClick={() => addAttachmentsDialog.handleOpen()} className='borderradius-default backgroundcolor-grey-2 text-color-1 display-flex gap-12'>
                            <Typography className='fontsize-14'>{translate('addAttachments')}</Typography>
                            <AttachFile fontSize="small" />
                        </IconButton>
                    </Badge>
                </Grid>
            </Grid>
        </Dialog>

        <AddAttachmentsDialog
            open={addAttachmentsDialog.open}
            handleClose={() => addAttachmentsDialog.handleClose()}
            attachments={state.values.attachments}
            handleUpdateAttachments={(files) => state.update('attachments', files)}
        />
    </>;
}

export default DoNotDisturbConfirmationDialog;